// extracted by mini-css-extract-plugin
export default {"item":"WatchListDraggableSettingsItem_item__HLELu","itemName":"WatchListDraggableSettingsItem_itemName__e88ES"};